import { render } from "./RegistrationAgreement.vue?vue&type=template&id=0e84a8fa&scoped=true&ts=true"
import script from "./RegistrationAgreement.vue?vue&type=script&lang=ts"
export * from "./RegistrationAgreement.vue?vue&type=script&lang=ts"

import "./RegistrationAgreement.vue?vue&type=style&index=0&id=0e84a8fa&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e84a8fa"]])

export default __exports__